import graphql__7aa849023e0b80c9ccbd from "./__generated__/ContributionsListFilters_participativeModule.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import Search from "../../Filters/Search";
import ContributionsCountBadge from "./ContributionsCountBadge";
import { useFormatMessage } from "../../Intl/Context";
import ContributionsListFiltersLoader from "./ContributionsListFiltersLoader";
import ThemeFilter from "../../Filters/ThemeFilter";
import BookmarkedFilter from "../../Filters/BookmarkedFilter";
import { useResponsiveFlag } from "../../Utils/ResponsiveQueries";
import { isAuthorized } from "../../Utils/authorizations";
import Collapse from "../../Utils/Collapse";
import CollapseSwitch from "../../Utils/CollapseSwitch";
import CollapseContent from "../../Utils/CollapseContent";
import Icon from "../../../components/Utils/Icon";

const ContributionsListFilters = ({
  collapsible = true,
  disableThemesFilter = false,
  disableBookmarkedFilter = false,
  disableSearch = false,
  ...props
}) => {
  const participativeModule = useFragment(
    ContributionsListFilters_participativeModule,
    props.participativeModule
  );

  // This is the fragment that's passed down to the filters loader component to be used
  // when refetching the data after a filter was changed.
  const { refetchFragment } = props;

  const { themes } = participativeModule;
  const { bookmarksCreationAuthorized } = participativeModule.authorizations;
  const hasMultipleFilters =
    (!disableThemesFilter && themes.length > 0) ||
    (!disableBookmarkedFilter && isAuthorized(bookmarksCreationAuthorized));

  // We force the filters to be collapsed by default on small screens
  const { isNonDesktop } = useResponsiveFlag();
  collapsible = isNonDesktop || collapsible;

  // If the filter list is collapsible, we use a more explicit title for the block
  const titleType = collapsible ? "filterContributions" : "filter";
  const t = useFormatMessage();
  const title = t(intlMessages[titleType]);

  const className = classNames(
    "filters-bar",
    "contributions-list-filters",
    "box",
    "margin-bottom-xs",
    { "filters-bar-multi": hasMultipleFilters }
  );

  const PanelContentComponent = collapsible ? CollapseContent : "div";

  return (
    <div className={className}>
      <Collapse>
        {collapsible && (
          <CollapseSwitch
            headingLevel={3}
            className="btn btn-primary-inverse btn-block-md box-shadow btn-expand-height padding-sm"
            hideCaret={true}
          >
            <span className="d-flex align-items-center w-100">
              <span className="d-block flex-1">{title}</span>
              <ContributionsCountBadge className="margin-x-sm" />

              <ContributionsListFiltersLoader
                refetchFragment={refetchFragment}
                refetchFragmentParent={props.participativeModule}
                spinnerClassName="inline-spinner button-icon-after"
              >
                <Icon className="icon-filter button-icon-after" />
              </ContributionsListFiltersLoader>
            </span>
          </CollapseSwitch>
        )}

        <PanelContentComponent>
          <div className="padding-sm filters-bar-filters">
            {!collapsible && (
              <>
                <div className="d-flex margin-right-sm">
                  <div className="margin-right-xs text-primary">
                    <ContributionsListFiltersLoader
                      refetchFragment={refetchFragment}
                      refetchFragmentParent={props.participativeModule}
                      spinnerClassName="inline-spinner button-icon-after"
                    >
                      <Icon className="icon-filter" />
                    </ContributionsListFiltersLoader>
                  </div>

                  {title}
                </div>
                <ContributionsCountBadge className="margin-x-sm" />
              </>
            )}

            {!disableThemesFilter && (
              <ThemeFilter participativeModule={participativeModule} />
            )}
            {!disableBookmarkedFilter && (
              <BookmarkedFilter participativeModule={participativeModule} />
            )}

            {!disableSearch && <Search />}
          </div>
        </PanelContentComponent>
      </Collapse>
    </div>
  );
};

const ContributionsListFilters_participativeModule = graphql__7aa849023e0b80c9ccbd;

export default ContributionsListFilters;

const intlMessages = defineMessages({
  filter: {
    id: "participativeModule.filters.filter",
    defaultMessage: "Filtrer"
  },
  filterContributions: {
    id: "participativeModule.filters.filterContributions",
    defaultMessage: "Filtrer les contributions"
  }
});
